<template>
	<div class="independent-wrapper" ref="box" id="pdfDom">
		<div class="fix-img">
			<div><img src="../../../static/images/result/baogaobg1.png" /></div>
		</div>
		<div class="content">
			<div class="con" ref="con">
				<!--脉象报告-->
				<div class="wrapper">
					<div class="item item-pulseReport" style="height: 260px;">
						<div class="pulseReport">舌面象报告</div>
						<div class="line pulseReportBottom">
							<div class="left" style="margin-left: 30px;">
								<div class="left-img" v-if="visitInfo.patient">
									<img v-show="visitInfo.patient.gender == '男'"
										src="../../../static/images/pluse/man.png" />
									<img v-show="visitInfo.patient.gender == '女'"
										src="../../../static/images/pluse/woman.png" />
								</div>
								<div class="left-right">
									<div class="p" v-if="visitInfo.patient">
										<span class="name">
											<i class="i">姓 名：</i>
											<i>{{ visitInfo.patient.name }}</i>
										</span>
										<span>
											<i class="i">性 别：</i>
											<i>{{ visitInfo.patient.gender }}</i>
										</span>
										<span>
											<i class="i">年 龄：</i>
											<i>{{ age }}岁</i>
										</span>
									</div>
									<div class="p">
										<span>
											<i class="i">位 置：</i>
											<i>{{ visitInfo.part }}</i>
										</span>
										<span v-if="visitInfo">
											<i class="i">时 间：</i>
											<i>{{ visitInfo.visitTime }}</i>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="wrapper-con">
					<!--总体结果-->
					<div class="item" :style="{'height':(reportResultList.length*60 + 185 + 98) + 'px'}">

						<div class="pulseDetail">
							<img src="../../../static/images/result/title1.png" alt="" />
						</div>
						<div class="imgTitle">诊断结果</div>
						<div class="item-line pulseResult" style="margin-top:120px;border: none;height:auto" >
							<div :style="{'height':(reportResultList.length*60 + 98) + 'px'}"  class="pulseResult-left" style="width: 100%;">
								<div class="line pluse" style="margin-left: 20px;">
									<span>
										<i class="i">诊断结果：</i>
									</span>
									<span style="position: relative;width: calc(100% - 150px);">
										<i style="margin-right: 10px;" v-for="(item,index) in reportResultListVal" :key="index">
											{{index+1}}.{{item}}
										</i>
									</span>
								</div>
								<div class="line pluse" v-for="(item,index) in reportResultList" :key="index"
									style="margin-top: 16px;margin-left: 20px;height: 60px;border-bottom: 0px;">
									<span style="float: left;width: 100%;">
										<i class="i">{{index+1}}.{{item.result}}</i>
										<i style="line-height: 20px;margin-left: 5px;">{{item.about}}</i>
									</span>

								</div>
							</div>

						</div>
						<div class="line margin26 add-p add-p-border"
							style="margin-top: 0;padding-top: 20px;display: none;" v-if="pulseResultList.length > 0">
							<ul class="pulseDec">
								<li v-for="(item, index) in pulseResultList" :key="index">
									<div class="dec-con">
										<div class="dec-con-left">
											<img src="../../../static/images/pluse/pluseDes.png" />
											<span :class="item.name.length > 1 ? 'twoWord' : ''">
												{{item.name}}
											</span>
										</div>
										<div class="dec-con-right">
											<div class="son">
												{{ item.about }}
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>

					</div>
					
					<!--面象分析-->
					<div class="item" style="display: none;" :style="{'height':(faceExplainList.length*100 + + 100 + 120) + 'px'}"  v-if="faceExplainList.length">
						<div class="item-cpmList" style="height: 100%;">
							<div class="pulseDetail">
								<img src="../../../static/images/result/title1.png" alt="" />
							</div>
							<div class="imgTitle">面象分析</div>
					
							<div style="margin-top:120px;" :style="{'height':(faceExplainList.length*100 + 100) + 'px'}"   class="item-line constitution tongueConstitution constitutionOne" >
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con">
											<img src="../../../static/images/face/mianzhen.png" />
										</div>
									</div>
									<div class="medicine-right">
					
										<div class="medicine-con">
											<div class="medicine-line" v-if="faceColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【面色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{faceColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in faceColorData">
													<div class="p-left tongueColorLeft">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right tongueColorRight">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="glossData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【光泽度】</span>
													<span style="font-size: 14px;font-weight:400">
														{{glossDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in glossData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="lipColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【唇色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{lipColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in lipColorData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="eyeData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【眼眶】</span>
													<span style="font-size: 14px;font-weight:400">
														{{eyeDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in eyeData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 空盒子 用来导出占位 -->
					<div class="item empty" v-if="reportResultList.length.length>3" :style="{'height':(pageHeight- (faceExplainList.length*100 + 100 + 120)) + 'px'}" style="border: 0px solid transparent;box-shadow: none;"></div>
					
					<!--舌象分析-->
					<div class="item "  :style="{'height':(tongueExplainList.length*100 + 150 + 350) + 'px'}"  style="margin-left:0px;" v-if="tongueExplainList.length>0">
						<div class="item-cpmList" style="height: 100%;">
							<div class="pulseDetail">
								<img src="../../../static/images/result/title1.png" alt="" />
							</div>
							<div class="imgTitle">舌面象分析</div>
					
							<div style="margin-top: 120px;" :style="{'height':(tongueExplainList.length*100 + 375) + 'px'}"  class="item-line constitution tongueConstitution constitutionOne" >
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con">
											<img class="faceImg" v-if="tongueUrl" :src="GLOBAL.imgPath + tongueUrl" />
											<img class="faceImg" v-else src="../../../static/images/face/shezhen.png" />
										</div>
									</div>
									<div class="medicine-right">
					
										<div class="medicine-con">
											<div class="medicine-line" v-if="tongueColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【舌色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{tongueColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in tongueColorData">
													<div v-if="item.value == '舌有瘀点或瘀斑' " class="p-left tongueColorLeft" style="width: 140px;">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div v-else class="p-left tongueColorLeft">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div v-if="item.value == '舌有瘀点或瘀斑' " class="p-right tongueColorRight" style="width: auto;">
														<span>{{item.significance}}</span>
													</div>
													<div v-else class="p-right tongueColorRight" >
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="tongueShapeData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【舌形】</span>
													<span style="font-size: 14px;font-weight:400">
														{{tongueShapeDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in tongueShapeData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="furColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【苔色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{furColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in furColorData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="furTextureData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【苔质】</span>
													<span style="font-size: 14px;font-weight:400">
														{{furTextureDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in furTextureData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="line margin26 marginAuto acupoint-div">
										<div class="medicine-left">
											<div class="medicine-left-con">
												<img class="faceImg" v-if="faceUrl" :src="GLOBAL.imgPath + faceUrl" />
												<img class="faceImg" v-else src="../../../static/images/face/mianzhen.png" />
											</div>
										</div>
										<div class="medicine-right">
													
											<div class="medicine-con">
												<div class="medicine-line" v-if="faceColorData.length>0">
													<div class="medicine-title">
														<span style="font-size: 14px;font-weight:bold">【面色】</span>
														<span style="font-size: 14px;font-weight:400">
															{{faceColorDataVal.join(',')}}
														</span>
													</div>
													<div class="div" :key="index" v-for="(item,index) in faceColorData">
														<div class="p-left tongueColorLeft">
															<span></span>
															<span>{{item.value}}：</span>
														</div>
														<div class="p-right tongueColorRight">
															<span>{{item.significance}}</span>
														</div>
													</div>
												</div>
												<div class="medicine-line" v-if="glossData.length>0">
													<div class="medicine-title">
														<span style="font-size: 14px;font-weight:bold">【光泽度】</span>
														<span style="font-size: 14px;font-weight:400">
															{{glossDataVal.join(',')}}
														</span>
													</div>
													<div class="div" :key="index" v-for="(item,index) in glossData">
														<div class="p-left">
															<span></span>
															<span>{{item.value}}：</span>
														</div>
														<div class="p-right">
															<span>{{item.significance}}</span>
														</div>
													</div>
												</div>
												<div class="medicine-line" v-if="lipColorData.length>0">
													<div class="medicine-title">
														<span style="font-size: 14px;font-weight:bold">【唇色】</span>
														<span style="font-size: 14px;font-weight:400">
															{{lipColorDataVal.join(',')}}
														</span>
													</div>
													<div class="div" :key="index" v-for="(item,index) in lipColorData">
														<div class="p-left">
															<span></span>
															<span>{{item.value}}：</span>
														</div>
														<div class="p-right">
															<span>{{item.significance}}</span>
														</div>
													</div>
												</div>
												<div class="medicine-line" v-if="eyeData.length>0">
													<div class="medicine-title">
														<span style="font-size: 14px;font-weight:bold">【眼眶】</span>
														<span style="font-size: 14px;font-weight:400">
															{{eyeDataVal.join(',')}}
														</span>
													</div>
													<div class="div" :key="index" v-for="(item,index) in eyeData">
														<div class="p-left">
															<span></span>
															<span>{{item.value}}：</span>
														</div>
														<div class="p-right">
															<span>{{item.significance}}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								
							</div>
						</div>
					</div>
					
					<!--体质表现-->
					<div class="item itemHeight" v-if="physiqueList.length>0" :style="{'height':(physiqueList.length*280 + 125) + 'px'}"  style="margin-left: 0px;margin-top: 0px;" >
						<div class="pulseDetail">
							<img src="../../../static/images/result/title1.png" alt="" />
						</div>
						<div class="imgTitle">体质辨识</div>
						<div style="margin-top: 120px;" :style="{'height':(physiqueList.length*280) + 'px'}">
							<div class="item-line constitution constitutionOne physiqueListCon"
								v-for="(item, index) in physiqueList" :key="index">
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con" v-if="item.images">
											<img v-for="item in item.images.slice(0, 1)" :key="item.name"
												:src="GLOBAL.imgPath + item.path" />
										</div>
									</div>
									<div class="medicine-right">
										<div class="medicine-title">【{{ item.name }}】</div>
										<div class="medicine-con">
											<div class="medicine-line">
												<div class="div">
													<div class="p-left">
														<span></span>
														<span>整体特征：</span>
													</div>
													<div class="p-right">
														<span> {{ item.body }} </span>
													</div>
												</div>
												<!-- <div class="div">
							  <div class="p-left">
							    <span></span>
							    <span>心理特征：</span>
							  </div>
							  <div class="p-right">
							    <span>{{ item.mental }}</span>
							  </div>
							</div> -->
												<div class="div">
													<div class="p-left">
														<span></span>
														<span>常见表现：</span>
													</div>
													<div class="p-right">
														<span>{{ item.performance }}</span>
													</div>
												</div>
												<!-- <div class="div">
							  <div class="p-left">
							    <span></span>
							    <span>发病倾向：</span>
							  </div>
							  <div class="p-right">
							    <span>{{ item.tend }}</span>
							  </div>
							</div> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<!--调理建议-->
					<div class="item">
						<!-- <div class="pulseDetail"><span>调理建议</span></div> -->
						<div class="pulseDetail">
							<img src="../../../static/images/result/title1.png" alt="" />
						</div>
						<div class="imgTitle">调理建议</div>
						<div class="item-line acupointHealthCare">
							<div class="acupointHealthCare-item" v-if="healthPlanList[0]">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">穴位保健</span>
								</div>
								<div class="contentItems">
									<div class="titleTwo titleTwoAnmo">【按摩】</div>
									<div v-for="(item, index) in healthPlanList[0].amAcupointList" :key="index"
										class="contentItem">
										<div class="nameAndOperation">
											<span>{{ index + 1 }}、</span>
											<span class="name">{{ item.name }} </span>
											<span>{{ item.operation }}</span>
										</div>
										<div class="effect">
											{{ item.effect }}
										</div>
									</div>
								</div>
								<div class="contentItems" v-for="(item, index) in physiotherapyCareList" :key="index">
									<div class="titleTwo">【{{ item.type }}】</div>
									<div class="acupoint">
										<span class="acupoint-name"><strong>穴位：</strong></span>
										<div class="acupoint-div">
											<span v-for="(item1, index1) in item.images" :key="index1" class="contentItem">
												{{ item1.name }}
												<span v-if="index1 != item.images.length - 1">、</span>
											</span>
										</div>
										
										
									</div>
									<div class="acupoint" >
										<span class="acupoint-name"><strong>方法：</strong></span>
										<div class="acupoint-div" v-html="item.ajOperation"></div>
									</div>
									<div class="acupoint" >
										<span class="acupoint-name"><strong>功效：</strong></span>
										<div  class="acupoint-div" v-html="item.ajEfficacy"></div>
									</div>
								</div>
							</div>
							<div class="acupointHealthCare-item" v-if="dietList">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">饮食建议</span>
								</div>
								<div class="contentItems">
									<div v-for="(item, index) in dietList" :key="index">
										<div class="titleTwo" :style="index == 0 ? 'marginTop:20px;' : ''">
											【{{ item.type }}】
										</div>
										<div class="contentItem">
											<div class="nameAndOperation">
												<div class="name">{{ item.name }}</div>
												<span>原料：{{ item.material }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="acupointHealthCare-item" v-if="traditionalExercisesList">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">运动生活</span>
								</div>
								<div class="contentItems">
									<div v-for="(item, index) in traditionalExercisesList" :key="index">
										<div class="contentItem" style="margin-left: 10px;">
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="acupointHealthCare-item" v-if="wellnessList">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">生活建议</span>
								</div>
								<div class="contentItems">
									<div class="contentItem" style="margin-left: 10px;">
										{{ wellnessList.content }}
									</div>
								</div>
							</div> -->
							<div style="display:none" class="acupointHealthCare-item" v-if="lifeGuideList">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">音乐疗法</span>
								</div>
								<div class="contentItems">
									<div v-for="(item, index) in lifeGuideList" :key="index">
										<div class="contentItem" style="margin-left: 10px;">
											{{ item.musicName }}
										</div>
									</div>
								</div>
							</div>
							<div class="acupointHealthCare-item" v-if="gfOrKljData">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">膏方推荐</span>
								</div>
								<div class="contentItems">
									<div class="contentItem" style="margin-left: 10px;">
										{{ gfOrKljData.name }}
									</div>
								</div>
							</div>
							<div class="acupointHealthCare-item" v-if="healthFoodList">
								<div class="titleItem">
									<div class="circle">
										<img src="../../../static/images/circle.png" alt="" />
									</div>
									<span class="titleOne">健康食品推荐</span>
								</div>
								<div class="contentItems">
									<div v-for="(item, index) in healthFoodList" :key="index">
										<div class="contentItem" style="margin-left: 10px;">
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import UQRCode from "uqrcodejs";
	import globle from "../../globle/globle";
	export default {
		data() {
			return {
				GLOBAL:globle,
				visitId: "",
				device: "",
				pulseResult: "",
				chiFirstValue: "",
				visitInfo: {},
				age: 0, //年龄
				regimenDetail: {
					diet: "",
					exercise: "",
					life: "",
				},
				outVisitId: "",
				canvasImg: require("../../../static/images/cunguanchi.png"),
				centerDialogVisible: false,
				timerTwo: null,
				hasTips: 0, //提示
				loginInfo: {},
				principleList: [],
				valOne: "",
				valTwo: "",
				valThree: "",
				valFour: "",
				pulseResultList: [],
				standardList: {},
				pulseResultTrit: [],
				LowStrengthData: [], //低强度
				medialStrengthData: [], //中强度
				highStrengthData: [], //高强度
				xAxisData: [],
				conH: 5500,
				exportPdfFlag: false,
				cpmIndex: 0,
				healthPlan: null,
				physiotherapyCareList: [],

				lifeGuideList: [],
				showPdfFlag: false,
				pdfTimer: null, //设置计时器,
				count: "",
				pointNum: 20,
				scroll: 0,
				wellnessList: "",
				healthAssessmentList: [], //健康评估列表
				healthAssessmentImgPath: "", //健康评估图片
				symptomList: [], //健康评估症状列表
				symptomListLeft: [],
				symptomListRight: [],
				physiqueName: "", //体质名称(体质1种时用)
				overview: "", //平和质综述
				loading: false,
				reportResultList: [], //诊断结果
				reportResultListVal: [], //诊断结果字符串
				explainList: [],
				tongueExplainList:[],
				faceExplainList:[],
				tongueData:[],
				tongueColorData: [], //舌色数据
				tongueShapeData: [], //舌形数据
				furColorData: [], //苔色数据
				furTextureData: [], //苔质数据
				tongueColorDataVal: [], //舌色名称
				tongueShapeDataVal: [], //舌色名称
				furColorDataVal: [], //舌色名称
				furTextureDataVal: [], //舌色名称	
				faceData:[],
				faceColorData: [], //面色数据
				glossData: [], //光泽度
				lipColorData: [], //唇色数据
				eyeData: [], //眼眶数据
				faceColorDataVal: [], //舌色名称
				glossDataVal: [], //舌色名称
				lipColorDataVal: [], //舌色名称
				eyeDataVal: [], //舌色名称			
				physiqueList: [], //体质辨识
				healthPlanList: [],
				dietList: [], //饮食推荐
				traditionalExercisesList: [], //传统功法
				exercisesList: [],
				gfOrKljData: [], //膏方
				healthFoodList: [], //健康食品
				gaofangUrl: [],
				healthFoodUrlList: [],
				pageHeight:0,
				printOption: {
					id: "pdfDom", // 打印元素的id 不需要携带#号
					preview: true, // 开启打印预览
				},
				faceUrl:'',
				tongueUrl:''
			};
		},

		methods: {
			/*
			  //膏方链接转二维码
			  creatQrCode() {
			    // 获取uQRCode实例
			    var qr = new UQRCode();
			    // 设置二维码内容
			    qr.data = this.gaofangUrl;
			    // 设置二维码大小，必须与canvas设置的宽高一致
			    qr.size = 100;
			    // 调用制作二维码方法
			    qr.make();
			    // 获取canvas元素
			    var canvas = document.getElementById("qrcodeGF");
			    // 获取canvas上下文
			    var canvasContext = canvas.getContext("2d");
			    // 设置uQRCode实例的canvas上下文
			    qr.canvasContext = canvasContext;
			    // 调用绘制方法将二维码图案绘制到canvas上
			    qr.drawCanvas();
			  },
			  //健康食品链接转二维码
			  creatQrCodeHealthFood() {
			    this.healthFoodUrlList.forEach((item, index) => {
			      if (item) {
			        // 获取uQRCode实例
			        var qr = new UQRCode();
			        // 设置二维码内容
			        qr.data = item;
			        // 设置二维码大小，必须与canvas设置的宽高一致
			        qr.size = 100;
			        // 调用制作二维码方法
			        qr.make();
			        // 获取canvas元素
			        var canvas = this.$refs.qrCodeUrlHealthFood[index];
			        console.log(canvas);
			        // 获取canvas上下文
			        var canvasContext = canvas.getContext("2d");
			        // 设置uQRCode实例的canvas上下文
			        qr.canvasContext = canvasContext;
			        // 调用绘制方法将二维码图案绘制到canvas上
			        qr.drawCanvas();
			      }
			    });
			  },
			  */
			//获取详情接口
			getPulseDetailAll(id) {
				this.$applicationJsonPrint("/business/visit/result/detail", {
						id: id, //734
					})
					.then((res) => {
						// console.log(res);
						if (res.data.code == 0) {
							this.visitInfo = res.data.data.visitInfo;
							this.age = this.getage(
								this.visitInfo.patient.birth,
								this.visitInfo.visitTime
							);
							//获取诊断结果
							this.getreportResultList(res.data.data.reportResultList);
							//处理舌象数据
							this.getExplainList(res.data.data);
							//体质辨识
							if (res.data.data.physiqueList.length > 0) {
								this.physiqueList = res.data.data.physiqueList;
							}
							//运动
							//this.initStrengthData();
							//this.myEcharts("runChart");
							//保健操
							this.exercisesList = res.data.data.exercisesList; //保健操
							//传统功法
							if (res.data.data.traditionalExercisesList.length > 0) {
								this.traditionalExercisesList = res.data.data.traditionalExercisesList;
								this.handleImgUrlTwo(res.data.data.traditionalExercisesList);
							}
							/* if (res.data.data.wellnessList) {
								this.wellnessList = res.data.data.wellnessList[0];
							} */
							//膏方
							if (res.data.data.healthPlanList.length > 0) {
								this.healthPlanList = res.data.data.healthPlanList;
								//饮食推荐dietList						
								this.getDietList();
								//艾灸 拔罐  刮痧
								this.handleAjData(this.healthPlanList[0]);
								this.handleBgData(this.healthPlanList[0]);
								this.handleGsData(this.healthPlanList[0]);
								//获取健康评估
								this.getHealthAssessmentList(this.healthPlanList[0]);
								//膏方	
								this.gfOrKljData = this.healthPlanList[0].medicinalFoodList[0];
								//健康食品
								this.healthFoodList = this.healthPlanList[0].healthFoodList;
								this.healthFoodList.map((item, index) => {
									this.healthFoodUrlList.push(item.buyUri);
								});
							}

							/**this.visitInfo = res.data.data.visitInfo;
							this.age = this.getage(
								this.visitInfo.patient.birth,
								this.visitInfo.visitTime
							);
							this.initStrengthData();
							// this.myEcharts("runChart");
							this.standardList = res.data.data.standard; ////获取最新标准
							let pulseResult = res.data.data.pulseResult;
							this.getPulseResultEx(pulseResult);
							this.pulseResultList = res.data.data.pulseExplain;
							console.log(this.pulseResultList);
							this.physiotherapyCareList = res.data.data.physiotherapyCareList; //艾灸拔罐
							this.exercisesList = res.data.data.exercisesList; //保健操
							if (res.data.data.lifeGuideList) {
								this.lifeGuideList = res.data.data.lifeGuideList; //音乐疗法
							}
							if (res.data.data.traditionalExercisesList) {
								this.traditionalExercisesList =
									res.data.data.traditionalExercisesList; //传统功法
							}
							if (res.data.data.healthPlan) {
								let healthPlan = res.data.data.healthPlan;
								this.healthPlan = healthPlan;
								this.handleImgUrl(healthPlan);
								this.gfOrKljData =
									res.data.data.healthPlan.physiqueList[0].medicinalFoods[0]; //膏方/颗粒剂
								this.gaofangUrl = this.gfOrKljData.buyUri;
								//健康评估
								this.healthAssessmentList = this.healthPlan.physiqueList;
								this.healthAssessmentImgPath = this.healthAssessmentList[0].healthAssessments[0]
									.images[0].path;
								if (this.healthAssessmentList.length == 1) {
									this.symptomList = this.healthAssessmentList[0].healthAssessments[0].symptoms;
									this.symptomList.map((item, index) => {
										if (index <= 2) {
											this.symptomListLeft.push(item);
										}
										if (index > 2) {
											this.symptomListRight.push(item);
										}
									});
									this.physiqueName = this.healthAssessmentList[0].name;
									if (this.physiqueName == "平和质") {
										this.overview =
											res.data.data.healthPlan.physiqueList[0].healthAssessments[0].overview;
									}
								}
								if (this.healthAssessmentList.length == 2) {
									this.healthAssessmentList[0].healthAssessments[0].symptoms.map(
										(item, index) => {
											if (index <= 2) {
												this.symptomListLeft.push(item);
											}
										}
									);

									let symptoms = this.healthAssessmentList[1].healthAssessments[0]
										.symptoms;
									for (let i = 0; i <= symptoms.length - 1; i++) {
										for (let j = 0; j <= this.symptomListLeft.length - 1; j++) {
											if (
												symptoms[i].symptom == this.symptomListLeft[j].symptom
											) {
												symptoms.splice(i, 1);
												i--;
											}
										}
									}
									this.$nextTick(() => {
										this.symptomListRight = symptoms.slice(0, 3);
									});
								}
							}
							if (res.data.data.healthFoodList) {
								this.healthFoodList = res.data.data.healthFoodList;
								this.healthFoodList.map((item, index) => {
									this.healthFoodUrlList.push(item.buyUri);
								});
							}
							if (res.data.data.wellnessList) {
								this.wellnessList = res.data.data.wellnessList[0];
							}
							this.handleImgUrlTwo(res.data.data.traditionalExercisesList);**/
						} else if (res.data.code == 500) {
							this.noDataFlag = true;
							this.$message.error("暂无有效数据");
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取诊断结果
			getreportResultList(reportResultList) {
				//诊断结果
				if (reportResultList.length > 0) {
					this.reportResultList = reportResultList;
					for (let i = 0; i < this.reportResultList.length; i++) {
						this.reportResultListVal.push(this.reportResultList[i].result)
					}
				}
			},
			//获取舌象分析
			getExplainList(item) {
				if (item.explainList.length > 0) {
					this.explainList = item.explainList;
					this.tongueData = item.tongueData;
					this.faceData = item.faceData;
					this.faceUrl = this.faceData.image;
					this.tongueUrl = this.tongueData.image;
					for (let i = 0; i < this.explainList.length; i++) {
						if(this.explainList[i].bodyPart == '舌'){
							this.tongueExplainList.push(this.explainList[i])
						}
						if(this.explainList[i].bodyPart == '面'){
							this.faceExplainList.push(this.explainList[i])
						}
						if (this.explainList[i].type == '舌色') {
							this.tongueColorData.push(this.explainList[i]);
							this.tongueColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '舌形') {
							this.tongueShapeData.push(this.explainList[i]);
							this.tongueShapeDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '苔色') {
							this.furColorData.push(this.explainList[i])
							this.furColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '苔质') {
							this.furTextureData.push(this.explainList[i])
							this.furTextureDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '面色') {
							this.faceColorData.push(this.explainList[i])
							this.faceColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '光泽度') {
							this.glossData.push(this.explainList[i])
							this.glossDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '唇色') {
							this.lipColorData.push(this.explainList[i])
							this.lipColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '眼眶') {
							this.eyeData.push(this.explainList[i])
							this.eyeDataVal.push(this.explainList[i].value);
						} 	
					}
				}
			},
			//获取饮食推荐
			getDietList() {
				//菜肴
				let cuisineList = this.healthPlanList[0].cuisineList;
				//粥实
				let porridgeList = this.healthPlanList[0].porridgeList;
				//汤羹
				let soupList = this.healthPlanList[0].soupList;
				//茶饮
				let teaList = this.healthPlanList[0].teaList;
				this.dietList.push(cuisineList[0]);
				this.dietList.push(porridgeList[0]);
				this.dietList.push(soupList[0]);
				this.dietList.push(teaList[0]);
			},
			//处理艾灸
			handleAjData(healthPlanList) {
				let ajAcupointList = healthPlanList.ajAcupointList;
				let ajAcupointListImgArr = [];
				let ajDataObj = {
					ajContraindication: '',
					ajEfficacy: '',
					ajOperation: '',
					ajPrecaution: '',
					images: '',
					type: ''
				}
				for (let i = 0; i < ajAcupointList.length; i++) {
					ajAcupointListImgArr.push(ajAcupointList[i].images[0]);
				}
				ajDataObj.ajContraindication = healthPlanList.ajContraindication;
				ajDataObj.ajEfficacy = healthPlanList.ajEfficacy;
				ajDataObj.ajOperation = healthPlanList.ajOperation;
				ajDataObj.ajPrecaution = healthPlanList.ajPrecaution;
				ajDataObj.images = ajAcupointListImgArr;
				ajDataObj.type = '艾灸';
				this.physiotherapyCareList.push(ajDataObj);

			},
			//处理拔罐
			handleBgData(healthPlanList) {
				let ajAcupointList = healthPlanList.bgAcupointList;
				let ajAcupointListImgArr = [];
				let ajDataObj = {
					ajContraindication: '',
					ajEfficacy: '',
					ajOperation: '',
					ajPrecaution: '',
					images: '',
					type: ''
				}
				for (let i = 0; i < ajAcupointList.length; i++) {
					ajAcupointListImgArr.push(ajAcupointList[i].images[0]);
				}
				ajDataObj.ajContraindication = healthPlanList.bgContraindication;
				ajDataObj.ajEfficacy = healthPlanList.bgEfficacy;
				ajDataObj.ajOperation = healthPlanList.bgOperation;
				ajDataObj.ajPrecaution = healthPlanList.bgPrecaution;
				ajDataObj.images = ajAcupointListImgArr;
				ajDataObj.type = '拔罐';
				this.physiotherapyCareList.push(ajDataObj);
			},
			//处理艾灸
			handleGsData(healthPlanList) {
				let ajAcupointList = healthPlanList.gsAcupointList;
				let ajAcupointListImgArr = [];

				let ajDataObj = {
					ajSummary: '',
					ajContraindication: '',
					ajEfficacy: '',
					ajOperation: '',
					ajPrecaution: '',
					images: '',
					type: ''
				}
				for (let i = 0; i < ajAcupointList.length; i++) {
					ajAcupointListImgArr.push(ajAcupointList[i].images[0]);
				}
				ajDataObj.ajContraindication = healthPlanList.gsContraindication;
				ajDataObj.ajEfficacy = healthPlanList.gsEfficacy;
				ajDataObj.ajOperation = healthPlanList.gsOperation;
				ajDataObj.ajPrecaution = healthPlanList.gsPrecaution;
				ajDataObj.ajSummary = healthPlanList.gsSummary;
				ajDataObj.images = ajAcupointListImgArr;
				ajDataObj.type = '刮痧';
				this.physiotherapyCareList.push(ajDataObj);
			},
			//健康评估
			getHealthAssessmentList(healthPlanList) {
				this.healthAssessmentList = healthPlanList.healthAssessmentList;
				this.healthAssessmentImgPath = this.healthAssessmentList[0].images[0].path;
				if (this.healthAssessmentList.length == 1) {
					this.symptomList = this.healthAssessmentList[0].symptoms;
					this.symptomList.map((item, index) => {
						if (index <= 2) {
							this.symptomListLeft.push(item);
						}
						if (index > 2) {
							this.symptomListRight.push(item);
						}
					});
					this.physiqueName = healthPlanList.name;
				}
			},


			//出生日期转化为年龄
			getage(date, visitTime) {
				var birthdays = new Date(date.replace(/-/g, "/"));
				var d = new Date(visitTime);
				var age =
					d.getFullYear() -
					birthdays.getFullYear() -
					(d.getMonth() < birthdays.getMonth() ||
						(d.getMonth() == birthdays.getMonth() &&
							d.getDate() < birthdays.getDate()) ?
						1 :
						0);
				return age;
			},
			getRad(degree) {
				return (degree / 180) * Math.PI;
			},

			liquidCharts(id, data, borderC, colorS, colorE, name) {
				let dom = document.getElementById(id);
				let myChart = this.echarts.init(dom);
				myChart.getZr().on("mousemove", (param) => {
					var pointInPixel = [param.offsetX, param.offsetY];
					if (myChart.containPixel("grid", pointInPixel)) {
						//若鼠标滑过区域位置在当前图表范围内 鼠标设置为小手
						myChart.getZr().setCursorStyle("pointer");
					} else {
						myChart.getZr().setCursorStyle("default");
					}
				});
				let option = null;
				option = {
					// 图表主标题
					title: {
						show: false,
						text: "槽使用情况",
						// x 设置水平安放位置，默认左对齐，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
						x: "10px",
						// y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
						y: "0px",
						// itemGap设置主副标题纵向间隔，单位px，默认为10，
						itemGap: 30,
						backgroundColor: "#fff",

						// 主标题文本样式设置
						textStyle: {
							fontSize: 16,
							fontWeight: "500",
							color: "#999",
						},
						// 副标题文本样式设置
					},
					// 提示框组件
					tooltip: {
						trigger: "item", // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
						textStyle: {
							color: "#999", // 文字颜色
						},
						// 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
						// 水球图: {a}（系列名称），{b}（无），{c}（数值）
						// 使用函数模板   传入的数据值 -> value: number|Array,
						formatter: function(value) {
							//return value.seriesName + ": " + value.data * 100 + "%";
						},
					},
					series: [{
						type: "liquidFill",
						name: name, // 系列名称，用于tooltip的显示，legend 的图例筛选
						radius: "89%", // 水球图的半径
						center: ["50%", "55%"], // 水球图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
						// 水填充图的形状 circle 默认圆形  rect 圆角矩形  triangle 三角形
						// diamond 菱形  pin 水滴状 arrow 箭头状  还可以是svg的path
						shape: "circle",
						phase: 0, // 波的相位弧度 不设置  默认自动
						waveAnimation: false, //停止动画 动画占用cpu过高 核心代码
						animationDuration: 0, //停止动画 动画占用cpu过高 核心代码
						animationDurationUpdate: 0, //停止动画 动画占用cpu过高 核心代码
						direction: "right", // 波浪移动的速度  两个参数  left 从右往左 right 从左往右
						amplitude: 4, //振幅设置为0，表示水平波浪
						outline: {
							show: true,
							borderDistance: 0, // 边框线与图表的距离 数字
							itemStyle: {
								opacity: 0.9, // 边框的透明度   默认为 1
								borderWidth: 2, // 边框的宽度
								shadowBlur: 14, // 边框的阴影范围 一旦设置了内外都有阴影
								//shadowColor: "#fff", // 边框的阴影颜色,
								borderColor: borderC, // 边框颜色
							},
						},
						// 图形样式
						itemStyle: {
							//color:'#fff', // 水球显示的背景颜色
							opacity: 1, // 波浪的透明度
							shadowBlur: 1, // 波浪的阴影范围
						},
						backgroundStyle: {
							color: "#fff", // 水球未到的背景颜色
						},
						// 图形的高亮样式
						emphasis: {
							itemStyle: {
								opacity: 1, // 鼠标经过波浪颜色的透明度
							},
						},
						// 图形上的文本标签
						label: {
							fontSize: 26,
							fontWeight: 400,
							show: false,
						},
						color: [{
							type: "linear",
							x: 0,
							y: 1,
							x2: 0,
							y2: 0,
							colorStops: [{
									offset: 1,
									color: colorS, // 0% 处的颜色
								},
								{
									offset: 0,
									color: colorE, // 100% 处的颜色
								},
							],
							global: false, // 缺省为 false
						}, ],
						data: data, // 系列中的数据内容数组
					}, ],
				};
				if (option && typeof option === "object") {
					myChart.setOption(option);
				}
			},
			drawLine(arr1, arr2, arr3, arr4) {
				//基于准本好的DOM，初始化echarts实例
				this.liquidCharts(
					"chartmainbar1", //参数1 id:加载的dom元素的id
					[arr1], //参数2 data:加入的数据,例如：[0.6]表示60%
					["#dbdbdb"], //参数3 borderD:边框颜色
					["#8FEFBD"], //参数4 color0:设置渐变色--水波图0%处的颜色
					["#7DADF6"], //参数5 color100:设置渐变色--水波图100%处的颜色
					"八纲"
				);
				this.liquidCharts(
					"chartmainbar2",
					[arr2],
					["#dbdbdb"],
					["#EB8715"],
					["#FFDDA0"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbar3",
					[arr3],
					["#dbdbdb"],
					["#BBD2F6"],
					["#9DDEFA"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbar4",
					[arr4],
					["#dbdbdb"],
					["#FFE88E"],
					["#CC7650"],
					"八纲"
				);
			},
			drawLineDiaog(arr1, arr2, arr3, arr4) {
				//console.log(arr1)
				//基于准本好的DOM，初始化echarts实例
				this.liquidCharts(
					"chartmainbarOne", //参数1 id:加载的dom元素的id
					[arr1], //参数2 data:加入的数据,例如：[0.6]表示60%
					["#dbdbdb"], //参数3 borderD:边框颜色
					["#8FEFBD"], //参数4 color0:设置渐变色--水波图0%处的颜色
					["#7DADF6"], //参数5 color100:设置渐变色--水波图100%处的颜色
					"八纲"
				);
				this.liquidCharts(
					"chartmainbarTwo",
					[arr2],
					["#dbdbdb"],
					["#EB8715"],
					["#FFDDA0"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbarThree",
					[arr3],
					["#dbdbdb"],
					["#BBD2F6"],
					["#9DDEFA"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbarFour",
					[arr4],
					["#dbdbdb"],
					["#FFE88E"],
					["#CC7650"],
					"八纲"
				);
			},

			async handleImgUrl(data) {
				data.dietList = data.dietList.reverse();
				/* for (let i = 0; i < data.dietList.length; i++) {
				                for (let j = 0; j < data.dietList[i].images.length; j++) {
				                    let base64 = await this.getImgBase64(this.GLOBAL.imgPath + data.dietList[i].images[j].path)
				                    data.dietList[i].images[j].path = base64;
				                }
				            }
				            for (let i = 0; i < data.acupointList.length; i++) {
				                for (let j = 0; j < data.acupointList[i].images.length; j++) {
				                    data.acupointList[i].images[j].path = await this.getImgBase64(this.GLOBAL.imgPath + data.acupointList[i].images[
				                        j].path)
				                }
				            } */
				this.regimenDetail = data;
			},
			async handleImgUrlTwo(data) {
				/* for (let i = 0; i < data.length; i++) {
				                for (let j = 0; j < data[i].images.length; j++) {
				                    data[i].images[j].path = await this.getImgBase64(this.GLOBAL.imgPath + data[i].images[
				                        j].path)
				                }
				            } */
				this.traditionalExercisesList = data;
				console.log(this.traditionalExercisesList);
			},

			getImgBase64(url) {
				return new Promise((resolve, reject) => {
					let base64 = "";
					let img = new Image();
					img.src = url;
					img.crossOrigin = "*";
					img.onload = function() {
						let canvas = document.createElement("canvas");
						canvas.width = img.width;
						canvas.height = img.height;
						let ctx = canvas.getContext("2d");
						ctx.drawImage(img, 0, 0, img.width, img.height);
						base64 = canvas.toDataURL("image/png");
						resolve(base64);
					};
					img.ononerror = function(e) {
						reject(e);
					};
				});
			},

			//导出PDF
			exportPdf() {
				let ST = document.documentElement.scrollTop || document.body.scrollTop;
				let SL = document.documentElement.scrollLeft || document.body.scrollLeft;
				document.documentElement.scrollTop = 0;
				document.documentElement.scrollLeft = 0;
				document.body.scrollTop = 0;
				document.body.scrollLeft = 0;
				//debugger;
				//获取滚动条的位置并赋值为0，因为是el-dialog弹框，并且内容较多出现了纵向的滚动条,截图出来的效果只能截取到视图窗口显示的部分,超出窗口部分则无法生成。所以先将滚动条置顶
				const A4_WIDTH = 592.28;
				const A4_HEIGHT = 841.89;
				let imageWrapper = document.getElementById("pdfDom"); // 获取DOM
				let pageHeight = (imageWrapper.offsetWidth / A4_WIDTH) * A4_HEIGHT;
				let lableListID = imageWrapper.querySelectorAll(".itemHeight");
				for (let i = 0; i < lableListID.length; i++) {
					let multiple = Math.ceil(
						(lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight
					);
					if (this.isSplit(lableListID, i, multiple * pageHeight)) {
						let divParent = lableListID[i].parentNode; // 获取该div的父节点
						let _H =
							multiple * pageHeight -
							(lableListID[i].offsetTop + lableListID[i].offsetHeight);
						let newNode = this.getFooterElement(_H);

						let next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
						// 判断兄弟节点是否存在
						if (next) {
							// 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
							divParent.insertBefore(newNode, next);
						} else {
							// 不存在则直接添加到最后,appendChild默认添加到divParent的最后
							divParent.appendChild(newNode);
						}
					}
				}
				this.$nextTick(() => {
					let nam =
						"脉诊仪报告_" +
						this.visitInfo.patient.name +
						"_" +
						this.visitInfo.visitTime.substring(0, 10) +
						"";
					console.log(nam);
					this.getPdf("pdfDom", nam);
					//downloadPDF(document.querySelector("#pdfDom"), "test");
					//var that = this;
					setTimeout(function() {
						//that.centerDialogVisible = false;
					}, 2000);
				});
			},
			isSplit(nodes, index, pageHeight) {
				return (
					nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight &&
					nodes[index + 1] &&
					nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight
				);
			},
			/**
			 * @description: 获取底部元素
			 */
			getFooterElement(remainingHeight, fillingHeight = 5) {
				let cpmItem = document.getElementById("cpmItem"); // 获取DOM
				if (cpmItem) {
					let imageWrapper = document.getElementById("pdfDom"); // 获取DOM
					if (imageWrapper.offsetWidth == 1000) {
						cpmItem.parentNode.style.marginTop = "150px";
					}
				}
				let newNode = document.createElement("div");
				newNode.style.background = "#ffffff";
				newNode.className = "emptyDiv";
				newNode.style.width = "calc(100% + 8px)";
				newNode.style.marginLeft = "-4px";
				newNode.style.marginBottom = "0px";
				newNode.style.float = "left";
				newNode.style.height = remainingHeight + fillingHeight + "px"; // pdf截断需要一个空白位置
				return newNode;
			},

			//雷达图
			drawRadar(radarChart) {
				//初始化echarts实例  this.pulseResultTrit
				let pulseResultTrit = [];
				this.pulseResultTritData = [];
				//沉浮----脉位
				if (this.pulseResultTrit[0] == 0) {
					pulseResultTrit.push("正常");
					this.pulseResultTritData[0] = 3;
				}
				if (this.pulseResultTrit[0] == 1) {
					pulseResultTrit.push("浮");
					this.pulseResultTritData[0] = 5;
				}
				if (this.pulseResultTrit[0] == 2) {
					pulseResultTrit.push("沉");
					this.pulseResultTritData[0] = 1;
				}

				//无力有力----脉力
				if (this.pulseResultTrit[2] == 0) {
					pulseResultTrit.push("正常");
					this.pulseResultTritData[1] = 3;
				}
				if (this.pulseResultTrit[2] == 1) {
					pulseResultTrit.push("有力");
					this.pulseResultTritData[1] = 5;
				}
				if (this.pulseResultTrit[2] == 2) {
					pulseResultTrit.push("无力");
					this.pulseResultTritData[1] = 1;
				}

				//数迟 ---脉率
				if (this.pulseResultTrit[3] == 0) {
					pulseResultTrit.push("正常");
					this.pulseResultTritData[2] = 3;
				}
				if (this.pulseResultTrit[3] == 1) {
					pulseResultTrit.push("数");
					this.pulseResultTritData[2] = 5;
				}
				if (this.pulseResultTrit[3] == 2) {
					pulseResultTrit.push("迟");
					this.pulseResultTritData[2] = 1;
				}

				//滑涩 ---流利度
				if (this.pulseResultTrit[1] == 0) {
					pulseResultTrit.push("正常");
					this.pulseResultTritData[3] = 3;
				}
				if (this.pulseResultTrit[1] == 1) {
					pulseResultTrit.push("滑");
					this.pulseResultTritData[3] = 5;
				}
				if (this.pulseResultTrit[1] == 2) {
					pulseResultTrit.push("涩");
					this.pulseResultTritData[3] = 1;
				}

				// 软弦 -- 紧张度
				if (this.pulseResultTrit[4] == 0) {
					pulseResultTrit.push("正常");
					this.pulseResultTritData[4] = 3;
				}
				if (this.pulseResultTrit[4] == 1) {
					pulseResultTrit.push("弦");
					this.pulseResultTritData[4] = 5;
				}
				if (this.pulseResultTrit[4] == 2) {
					pulseResultTrit.push("软");
					this.pulseResultTritData[4] = 1;
				}

				this.pulseResultTritCopy = pulseResultTrit;
				let myChart = this.echarts.init(document.getElementById(radarChart));
				//绘制图表
				var optionOne = {
					title: {
						text: " ",
					},
					grid: {
						//同radar里的center[]
						position: "center",
					},
					tooltip: {
						confine: true,
						enterable: true, //鼠标是否可以移动到tooltip区域内
					},
					radar: {
						center: ["50%", "57%"], //调位置
						radius: 80, //调大小
						startAngle: 90,
						splitNumber: 3, //雷达图圈数设置
						//雷达图形状圆形    	shape:'circle',
						name: {
							formatter: "{value}",
							textStyle: {
								color: "#666",
								fontWeight: "bold",
							},
						},
						//雷达图的指示器，指定雷达图的多个维度脉位、脉力、脉率、流利度、紧张度
						indicator: [{
								text: "脉位",
								max: 6,
							},
							{
								text: "脉力",
								max: 6,
							},
							{
								text: "脉率",
								max: 6,
							},
							{
								text: "流利度",
								max: 6,
							},
							{
								text: "紧张度",
								max: 6,
							},
						],
						splitArea: {
							areaStyle: {
								color: ["#77EADF", "#64AFE9", "#428BD4"],
								shadowColor: "rgba(0, 0, 0, 0.2)",
								shadowBlur: 10,
							},
						},
						shape: "circle",

						axisLine: {
							lineStyle: {
								color: "rgba(211, 253, 250, 0.8)",
							},
						},
						splitLine: {
							lineStyle: {
								color: "rgba(211, 253, 250, 0.8)",
							},
						},
					},

					series: [{
						name: "雷达图",
						type: "radar",
						symbol: "circle", //拐点样式
						symbolSize: 6, //拐点大小
						areaStyle: {
							//拐点颜色
							narmal: {
								width: 1,
								opacity: 0.2,
								color: "#0184BB",
							},
						},
						tooltip: {
							formatter: function() {},
						},
						data: [{
							//设置各个指标的值
							value: this.pulseResultTritData,
							home: pulseResultTrit,
							label: {
								show: true,
								formatter: function(params) {
									return params.data.home[params.dimensionIndex];
								},
							},
							//设置区域的颜色
							itemStyle: {
								normal: {
									color: "rgba(255, 228, 52, 0.6)",
								},
							},
						}, ],
					}, ],
				};
				myChart.setOption(optionOne); //设置option
			},
			//运动生活
			myEcharts(runChart) {
				let myChart = this.echarts.init(document.getElementById(runChart));
				//绘制图表
				var optionOne = {
					title: {
						text: "运动适宜心率",
						left: "center",
						textStyle: {
							//文字颜色
							color: "#333",
							//字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
							fontWeight: "normal",
							//字体大小
							fontSize: 16,
						},
					},
					tooltip: {
						trigger: "axis",
						axisPointer: {
							type: "cross",
							label: {
								backgroundColor: "#6a7985",
							},
						},
					},
					legend: {
						orient: "vertical",
						right: "left",
						bottom: "20%",
						data: ["高强度", "中强度", "低强度"],
					},

					grid: {
						left: "30",
						right: "14%",
						bottom: "3%",
						containLabel: true,
					},
					xAxis: [{
						type: "category",
						boundaryGap: false,
						data: this.xAxisData,
						name: "年龄（岁）",
					}, ],
					yAxis: [{
						type: "value",
						min: 60,
						max: 180,
						interval: 60,
						name: "心率（次/分钟）",
					}, ],
					series: [{
							name: "高强度",
							type: "line",
							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#8BE041",
									lineStyle: {
										color: "#8BE041",
									},
								},
							},
							areaStyle: {
								normal: {
									//由上到下的渐变
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: "#8BE041",
										},
										{
											offset: 0.24,
											color: "#8BE041",
										},
										{
											offset: 0.25,
											color: "#7FA7E7",
										},
										{
											offset: 1,
											color: "#F0AF85",
										},
									]),
								},
							},
							data: this.highStrengthData,
						},
						{
							name: "中强度",
							type: "line",
							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#7FA7E7",
									lineStyle: {
										color: "#7FA7E7",
									},
								},
							},
							areaStyle: {
								normal: {
									//由上到下的渐变
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: "#7FA7E7",
										},
										{
											offset: 0.05,
											color: "#7FA7E7",
										},
										{
											offset: 1,
											color: "#F0AF85",
										},
									]),
								},
							},

							data: this.medialStrengthData,
						},
						{
							name: "低强度",
							type: "line",

							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#F0AF85",
									lineStyle: {
										color: "#F0AF85",
									},
								},
							},
							areaStyle: {
								normal: {
									//由上到下的渐变
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: "#F0AF85",
										},
										{
											offset: 1,
											color: "#F0AF85",
										},
									]),
								},
							},
							data: this.LowStrengthData,
						},
					],
				};
				myChart.setOption(optionOne); //设置option
				let index = this.xAxisData.indexOf(this.age);
				myChart.dispatchAction({
					type: "showTip",
					seriesIndex: 0, // 显示第几个series，从0开始
					dataIndex: index, // 显示第几个数据，从0开始
				});
				myChart.on("globalout", function(params) {
					// 显示 tooltip
					myChart.dispatchAction({
						type: "showTip",
						seriesIndex: 0,
						dataIndex: index,
					});
				});
			},
			initStrengthData() {
				//console.log(this.age)
				let xAxisData = [6, 18, 50, 65, 80];
				let LowStrengthData = [125, 125, 102, 69, 45];
				let medialStrengthData = [145, 145, 119, 80, 56];
				let highStrengthData = [165, 165, 136, 92, 64];
				if (this.age < 6) {
					this.xAxisData = xAxisData;
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
				}
				if (this.age >= 6 && this.age <= 18) {
					this.xAxisData = xAxisData;
					if (this.age < 18) {
						this.xAxisData.splice(1, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					this.LowStrengthData.splice(1, 0, 125);
					this.medialStrengthData.splice(1, 0, 145);
					this.highStrengthData.splice(1, 0, 165);
				}
				if (this.age > 19 && this.age <= 50) {
					this.xAxisData = xAxisData;
					if (this.age < 50) {
						this.xAxisData.splice(2, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					let lowData = Math.floor((220 - this.age) * 0.6);
					let medeialData = Math.floor((220 - this.age) * 0.7);
					let highData = Math.floor((220 - this.age) * 0.8);
					this.LowStrengthData.splice(2, 0, lowData);
					this.medialStrengthData.splice(2, 0, medeialData);
					this.highStrengthData.splice(2, 0, highData);
				}
				if (this.age > 50 && this.age <= 65) {
					this.xAxisData = xAxisData;
					if (this.age < 65) {
						this.xAxisData.splice(3, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					let lowData = Math.floor((170 - this.age) * 0.6);
					let medeialData = Math.floor((170 - this.age) * 0.7);
					let highData = Math.floor((170 - this.age) * 0.8);
					this.LowStrengthData.splice(3, 0, lowData);
					this.medialStrengthData.splice(3, 0, medeialData);
					this.highStrengthData.splice(3, 0, highData);
				}
				if (this.age > 66 && this.age <= 80) {
					this.xAxisData = xAxisData;
					if (this.age < 80) {
						this.xAxisData.splice(4, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					let lowData = Math.floor((170 - this.age) * 0.6 * 0.9);
					let medeialData = Math.floor((170 - this.age) * 0.7 * 0.9);
					let highData = Math.floor((170 - this.age) * 0.8 * 0.9);
					this.LowStrengthData.splice(4, 0, lowData);
					this.medialStrengthData.splice(4, 0, medeialData);
					this.highStrengthData.splice(4, 0, highData);
				}
			},
			//切换丸
			changeCpmList(index) {
				this.cpmIndex = index;
			},
			//去播放视频视频
			goLookVideo(com, item) {
				if (com == "one") {
					let videoPlayDetail = item;
					localStorage.setItem(
						"videoPlayDetail",
						JSON.stringify(videoPlayDetail)
					);
					localStorage.setItem("acupointList", "");
				} else {
					let acupointList = this.healthPlan.acupointList;
					localStorage.setItem("acupointList", JSON.stringify(acupointList));
					localStorage.setItem("masterMediaUri", "");
				}
				this.$router.push({
					path: "/historyList/lookVideo",
					query: {
						com: com,
					},
				});
			},
			//initH
			initHeight() {
				//获取滚动条的位置并赋值为0，因为是el-dialog弹框，并且内容较多出现了纵向的滚动条,截图出来的效果只能截取到视图窗口显示的部分,超出窗口部分则无法生成。所以先将滚动条置顶
				const A4_WIDTH = 592.28;
				const A4_HEIGHT = 841.89;
				let imageWrapper = document.getElementById("pdfDom"); // 获取DOM
				let pageHeight = (imageWrapper.offsetWidth / A4_WIDTH) * A4_HEIGHT;
				this.pageHeight = pageHeight;
			}
		},
		created() {
			this.$nextTick(() => {
				this.visitId = this.$route.query.visitId;
				this.pulseResult = this.$route.query.pulseResult;
				this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				this.getPulseDetailAll(this.visitId);
				this.initHeight();
			});
		},
		mounted() {
			this.$nextTick(() => {});
		},
		activated() {
			this.$refs.box.scrollTop = this.scroll;
		},
		/* beforeRouteLeave(to, from, next) {
			if (to.name != "lookVideo") {
				let key = this.$vnode.componentOptions.Ctor.cid;
				//获取所有路由的key值
				let keys = this.$vnode.parent.componentInstance.keys;
				if (null != key && undefined != key) {
					//将需要清空路由缓存的key移除
					keys.splice(keys.indexOf(key), 1);
					//获取该key值对应的缓存
					let cache = this.$vnode.parent.componentInstance.cache;
					//删除该缓存
					delete cache[key];
				}
			} else {
				this.scroll = this.$refs.box.scrollTop;
			}
			next();
		}, */
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/reportShort.less";

	@media print {}

	.independent-wrapper {
		font-variant: normal;
	}

	:deep(.el-dialog__header){
		display: none;
	}

	:deep(.el-dialog__body){
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.pulseResult-right {
		float: right;

		.circleBox {
			position: relative;
			text-align: center;
			width: 200px;
			margin: 40px 0;
			float: right;

			.circleCenter {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

				div {
					font-size: 26px;
					color: #1360FB;
					font-weight: 600;
					margin-bottom: 5px;
				}

				span {
					font-size: 14px;
					color: #999999;
				}
			}
		}

	}
</style>
